export const text = {
  FILES: 'Files',
  NO_FILES: 'No files',
  NEW: 'New',
  ADD_NEW_FILE: 'Add new file',
}

export const styles = {
  NEW_BUTTON_IMAGE_STYLE: {
    height: 16.5,
    width: 16.5,
    marginRight: 5,
  },

  NEW_BUTTON_STYLE: {
    justifyContent: 'center',
    maxHeight: 40,
    width: 88,
    marginRight: 24,
  },
}
export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'bmp', 'csv']
const ALLOWED_FILE_EXTENSIONS_ERROR = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.bmp', '.csv']
export const ALLOWED_FILE_EXTENSIONS_STR = ALLOWED_FILE_EXTENSIONS_ERROR.join(', ')
export const SIZE_10_MB = 10485760

export const TAG_OPTIONS = [
  { value: 'DiagnosticTests', isActive: false },
  { value: 'DrugScreen', isActive: false },
  { value: 'Insurance', isActive: false },
  { value: 'LabResults', isActive: false },
  { value: 'OBOT', isActive: false },
  { value: 'Correspondence', isActive: false },
  { value: 'Forms', isActive: false },
  { value: 'PDMP', isActive: false },
  { value: 'CounselingVerification', isActive: false },
  { value: 'IDVerified', isActive: false },
  { value: 'FrontOfID', isActive: false },
  { value: 'BackOfID', isActive: false },
  { value: 'Other', isActive: false },
]
export const multiSelectDropdownStyles = {
  width: 442,
}

export const dropdownContainerStyle = {
  top: 68,
  right: 0,
}
